module.exports = __webpack_public_path__ + "img/date.287eaab3.svg";